import React from 'react';

const Nosotros = () => {
  return (
    <section id="nosotros" className="nosotros">
      <div className='seccionNosotros'>
        <h1>De Buenos Aires a la estratosfera</h1>

        <p>
            Somos un equipo multidisciplinario con años de experiencia en televisión,
            cine y redes
        </p>

        <p>
          Dentro del Volcán habitamos productores, realizadores, diseñadores y
          animadores. Somos creadores apasionados y sobre todo, somos contadores de
          historias.
        </p>
        <p>
          En Volcán nos gustan los desafíos y la realización en todo tipo de formato
        </p>
        <p>Conectamos marcas con personas</p>

        <p>
          Contanos tus ideas que nosotros las hacemos realidad. Somos distintos,
          somos VOLCÁN
        </p>
      </div>

  </section>
  )
}

export default Nosotros